const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT

export const getEnvURL = () => {
    if(ENVIRONMENT === "PROD") return "https://recroid.com"
    if(ENVIRONMENT === "DEV") return "https://frontend-dev-ssfw.onrender.com"
    if(ENVIRONMENT === "LOCAL") return "http://localhost:3000"
    return "https://recroid.com"
}